export enum BtnClasses {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  Default = 'default',
  Tertiary = 'tertiary',
  Inverse = 'inverse',
  LinkPrimary = 'link-primary',
  LinkSecondary = 'link-secondary',
  LinkDanger = 'link-danger',
}

export type AlertRole = 'alert' | 'alertdialog' | 'status';
